import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    document.addEventListener("show-session-modal", this.showWithEmail.bind(this))
  }

  disconnect() {
    document.removeEventListener("show-session-modal", this.showWithEmail.bind(this))
  }

  showWithEmail(event) {
    $("#session-modal").modal("show")
    const { email, title } = event.detail
    if (title) {
      $("#session-body .modal-title").html(title)
    }
    if (email) {
      const input = document.getElementById("user_login")
      input.value = email
    }
  }
}
